import { Form, Modal, Input, Button } from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { useEffect } from "react";

const ClientContactModal = ({ open, close, onSave, contacts }) => {
    const [form] = Form.useForm();

    const handleSubmit = () => {
        form.validateFields()
            .then((values) => {
                const contactValues = values.contacts.map((contact) => {
                    return {
                        isActive: true,
                        id: contact.id,
                        firstName: contact.firstName,
                        lastName: contact.lastName,
                        email: contact.email,
                        phone: contact.phone,
                    };
                });

                onSave(contactValues);
                close();
            })
            .catch((info) => {
                console.log("Validate Failed:", info);
            })

    }

    useEffect(() => {
        if (contacts) {
            const values = contacts.map((contact) => {
                return {
                    id: contact.id,
                    firstName: contact.firstName,
                    lastName: contact.lastName,
                    email: contact.email,
                    phone: contact.phone,
                };
            });
            form.setFieldValue('contacts', values);
        }
    }, [contacts, form])

    return (
        <Modal
            getContainer={false}
            title="Add Contact"
            open={open}
            onCancel={close}
            onOk={handleSubmit}
            className="min-w-[700px] max-w-[700px]"
        >
            <Form
                form={form}
                layout="vertical"
                className="mt-12 min-h-[500px] max-h-[500px] overflow-y-scroll"
            >
                <Form.List name="contacts">
                    {(fields, { add, remove }) => (
                        <>
                            {fields.map(({ key, name, ...restField }) => (
                                <div
                                    key={key}
                                    className="grid grid-cols-4 gap-2 items-baseline relative overflow-hidden"
                                >
                                    <Form.Item
                                        {...restField}
                                        key={key}
                                        name={[name, 'firstName']}
                                        label="First Name"
                                        rules={[{ required: true, message: 'Missing name' }]}
                                    >
                                        <Input placeholder="First Name" />
                                    </Form.Item>
                                    <Form.Item
                                        {...restField}
                                        key={key}
                                        name={[name, 'lastName']}
                                        label="Last Name"
                                        rules={[{ required: true, message: 'Missing last name' }]}
                                    >
                                        <Input placeholder="Last Name" />
                                    </Form.Item>

                                    <Form.Item
                                        {...restField}
                                        key={key}
                                        name={[name, 'email']}
                                        label="Email"
                                    // rules={[{ required: false, message: 'Missing last name' }]}
                                    >
                                        <Input placeholder="Email" />
                                    </Form.Item>
                                    <Form.Item
                                        {...restField}
                                        key={key}
                                        name={[name, 'phone']}
                                        label="Phone"
                                        rules={[{ required: true, message: 'Phone' }]}
                                    >
                                        <Input placeholder="Phone" />
                                    </Form.Item>
                                    <MinusCircleOutlined
                                        onClick={() => remove(name)}
                                        className="absolute top-0 right-0"
                                    />
                                </div>
                            ))}
                            <Form.Item>
                                <Button
                                    type="dashed"
                                    onClick={() => add()}
                                    block
                                    icon={<PlusOutlined />}
                                    style={{ width: "140px" }}
                                >
                                    Add Contact
                                </Button>
                            </Form.Item>
                        </>
                    )}
                </Form.List>
            </Form>

        </Modal>
    )
}

export default ClientContactModal;
